import React from 'react';

export default function Footer() {
  return (
    <footer
      className="border-t"
      style={{
        borderColor: 'rgba(26,26,26,0.08)',
        background: 'var(--cotton-rag)'
      }}>

      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Left: Logo + tagline */}
        <div className="flex items-center gap-4">
          <span
            className="text-sm font-bold tracking-[0.12em] uppercase"
            style={{ color: 'var(--forge-black)', fontFamily: 'Manrope, sans-serif' }}>

            Tony Taylor
          </span>
          <span
            className="text-xs hidden md:block"
            style={{ color: 'var(--plate-gray)', fontFamily: 'Manrope, sans-serif' }}>Tony Taylor - Melbourne, AUS


          </span>
        </div>

        {/* Center links */}
        <nav className="flex items-center gap-6">
          {[
            { label: 'Instagram', href: 'https://instagram.com/tony.taylxr', target: '_blank' },
            { label: 'Studio', href: 'https://heaviside.club', target: '_blank' }].
          map(({ label, href, target }) =>
          <a
            key={label}
            href={href}
            target={target}
            rel={target === '_blank' ? 'noopener noreferrer' : undefined}
            className="text-xs font-medium transition-colors duration-200"
            style={{
              color: 'var(--burnished-pewter)',
              fontFamily: 'Manrope, sans-serif',
              letterSpacing: '0.06em'
            }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLAnchorElement).style.color = 'var(--brayer-red)';
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLAnchorElement).style.color = 'var(--burnished-pewter)';
            }}>

              {label}
            </a>
          )}
        </nav>

        {/* Right: copyright */}
        <span
          className="text-xs"
          style={{ color: 'var(--plate-gray)', fontFamily: 'Manrope, sans-serif' }}>© 2026  Tony Taylor


        </span>
      </div>
    </footer>);

}